import React from "react";
import Eighth from "./eighth";
import "./breakdown.scss";
import ScriptItems from "./script-items";
import { Link } from "react-router-dom";
import CharactersIcon from '../../films/icons/characters';
import CostumesIcon from '../../films/icons/costumes';
import MakeupIcon from '../../films/icons/makeup';
import BackgroundCharactersIcon from '../../films/icons/background-characters';
import PropsIcon from '../../films/icons/props';
import SetSressingsIcon from '../../films/icons/set-dressings';
import VisualEffectsIcon from '../../films/icons/visual-effects';
import SoundEffectsIcon from '../../films/icons/sound-effects';
import { ItemTypes } from "./constants";

const Scene = ({ scene,
  filmId,
  readOnly,
  onDropItem,
  changeCharacterToBackgroundCharacter,
  changeBackgroundCharacterToCharacter,
  changePropToSetDressing,
  changePropToCostume,
  changeSetDressingToProp,
  changeCostumeToProp,
  deleteProp,
  deleteCharacter,
  deleteBackgroundCharacter,
  deleteSetDressing,
  deleteCostume,
  deleteMakeup,
  deleteVisualEffect,
  deleteSoundEffect,
  canAccessBackgroundCharacters,
  canAccessCharacters,
  canAccessCostumes,
  canAccessMakeups,
  canAccessProps,
  canAccessSetDressings,
  canAccessVisualEffects,
  canAccessSoundEffects
}) => {

  const onChangeCharacterToBackgroundCharacter = (item, destination) => {
    changeCharacterToBackgroundCharacter(filmId, item.item);
  };

  const onChangeBackgroundCharacterToCharacter = (item, destination) => {
    changeBackgroundCharacterToCharacter(filmId, item.item);
  };

  const onChangePropTo = (item, destination) => {
    if (destination === ItemTypes.SET_DRERSSING) {
      changePropToSetDressing(filmId, item.item);
    } else if (destination === ItemTypes.COSTUME) {
      changePropToCostume(filmId, item.item);
    }
  };

  const onChangePropFrom = (item, destination) => {
    if (item.type === ItemTypes.SET_DRERSSING) {
      changeSetDressingToProp(filmId, item.item);
    } else if (item.type === ItemTypes.COSTUME) {
      changeCostumeToProp(filmId, item.item);
    }
  };

  const addCharacter = () => {

  };

  return (
    <div className="scene-breakdown">
      <div>
        <label>Scene:</label>{" "}
        <Link to={`/films/${filmId}/scenes/${scene.id}`}>{scene.number}</Link>
      </div>
      <div>
        <label>Scene Setting:</label>{" "}
        <Link to={`/films/${filmId}/scene-settings/${scene.sceneSettingId}`}>
          {scene.sceneSetting}
        </Link>
      </div>
      {scene.interiorExteriorDescription && (
        <div>
          <label>Int/Ext:</label> {scene.interiorExteriorDescription}
        </div>
      )}
      {scene.dayNightDescription && (
        <div>
          <label>Day/Night:</label> {scene.dayNightDescription}
        </div>
      )}
      {scene.pageStart && (
        <div>
          <label>Script Pages:</label> <Eighth page={scene.pageStart} /> -{" "}
          <Eighth page={scene.pageEnd} /> (<Eighth page={scene.pageLength} />)
        </div>
      )}
      {scene.location && (
        <div>
          <label>Location:</label> {scene.location}
        </div>
      )}
      <div className="break"></div>
      {scene.summary && (
        <>
          {" "}
          <div>
            <label>Summary:</label> {scene.summary}
          </div>
          <div className="break"></div>
        </>
      )}
      <hr />
      <div className="columns is-multiline">
        {canAccessCharacters && <ScriptItems
          label="Characters"
          icon={CharactersIcon}
          items={scene.characters}
          url={`/films/${filmId}/scenes/${scene.id}/characters/`}
          readOnly={readOnly}
          allowedItemTypes={[ItemTypes.BACKGROUND_CHARACTER]}
          itemType={ItemTypes.CHARACTER}
          dropItem={onChangeBackgroundCharacterToCharacter}
          canDrag={true}
          deleteItem={deleteCharacter}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/characters/add`}
          addItemLink={null}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
        />}
        {canAccessBackgroundCharacters && <ScriptItems
          label="Background Characters"
          icon={BackgroundCharactersIcon}
          items={scene.backgroundCharacters}
          url={`/films/${filmId}/scenes/${scene.id}/background-characters/`}
          readOnly={readOnly}
          allowedItemTypes={[ItemTypes.CHARACTER]}
          itemType={ItemTypes.BACKGROUND_CHARACTER}
          dropItem={onChangeCharacterToBackgroundCharacter}
          canDrag={true}
          deleteItem={deleteBackgroundCharacter}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/background-characters/add`}
          addItemLink={null}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
        />}

        {canAccessProps && <ScriptItems
          label="Props"
          icon={PropsIcon}
          items={scene.props}
          url={`/films/${filmId}/props/`}
          readOnly={readOnly}
          allowedItemTypes={[ItemTypes.COSTUME, ItemTypes.SET_DRERSSING]}
          itemType={ItemTypes.PROP}
          dropItem={onChangePropFrom}
          canDrag={true}
          deleteItem={deleteProp}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/props/add`}
          addItemLink={`/films/${filmId}/props/add`}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
        />}

        {canAccessSetDressings && <ScriptItems
          label="Set Dressing"
          icon={SetSressingsIcon}
          items={scene.setDressings}
          url={`/films/${filmId}/set-dressings/`}
          readOnly={readOnly}
          allowedItemTypes={[ItemTypes.PROP]}
          itemType={ItemTypes.SET_DRERSSING}
          dropItem={onChangePropTo}
          canDrag={true}
          deleteItem={deleteSetDressing}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/set-dressings/add`}
          addItemLink={`/films/${filmId}/set-dressings/add`}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
          sceneSettingId={scene.sceneSettingId}
        />}

        {canAccessCostumes && <ScriptItems
          label="Costumes"
          icon={CostumesIcon}
          items={scene.costumes}
          url={`/films/${filmId}/costumes/`}
          readOnly={readOnly}
          allowedItemTypes={[ItemTypes.PROP]}
          itemType={ItemTypes.COSTUME}
          dropItem={onChangePropTo}
          canDrag={true}
          deleteItem={deleteCostume}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/costumes/add`}
          addItemLink={`/films/${filmId}/costumes/add`}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
        />}

        {canAccessMakeups && <ScriptItems
          label="Makeup/Hair"
          icon={MakeupIcon}
          items={scene.makeups}
          url={`/films/${filmId}/makeup/`}
          readOnly={readOnly}
          allowedItemTypes={[]}
          itemType={ItemTypes.MAKEUP}
          dropItem={onDropItem}
          canDrag={false}
          deleteItem={deleteMakeup}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/makeup/add`}
          addItemLink={`/films/${filmId}/makeup/add`}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
        />}

        {canAccessVisualEffects && <ScriptItems
          label="Visual Effects"
          icon={VisualEffectsIcon}
          items={scene.visualEffects}
          url={`/films/${filmId}/visual-effects/`}
          readOnly={readOnly}
          allowedItemTypes={[]}
          itemType={ItemTypes.VISUAL_EFFECT}
          dropItem={onDropItem}
          canDrag={false}
          deleteItem={deleteVisualEffect}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/visual-effects/add`}
          addItemLink={`/films/${filmId}/visual-effects/add`}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
        />}

        {canAccessSoundEffects && <ScriptItems
          label="Sound Effects"
          icon={SoundEffectsIcon}
          items={scene.soundEffects}
          url={`/films/${filmId}/sound-effects/`}
          readOnly={readOnly}
          allowedItemTypes={[]}
          itemType={ItemTypes.SOUND_EFFECT}
          dropItem={onDropItem}
          canDrag={false}
          deleteItem={deleteSoundEffect}
          assignItemLink={`/films/${filmId}/scenes/${scene.id}/sound-effects/add`}
          addItemLink={`/films/${filmId}/sound-effects/add`}
          returnUrl={`/films/${filmId}/breakdown/scenes/${scene.id}`}
          sceneId={scene.id}
        />}
      </div>
    </div>
  );
};

export default Scene;
